import React, { FC, useEffect, useState, memo } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import ComposePaypalViewModel, { IPayPalViewModel } from './viewModel';
import styled from 'styled-components';
import Loader from './loader';
import { useSelector } from 'react-redux';
import APIServices from '../../../../../../../../utils/services/EveryDoggyAPIServices';
import errorLogger from '../../../../../../../../utils/errorLogger/appErrorLogger';
import { SubscriptionPaypalButtons } from './subscriptionPaypalButtons';
import getCurrencyValue from '../../../../../../../../utils/scripts/getCurrencyValue';

const PaypalComponentContainer = styled.div`
  height: 55px;
  width: 100%;
  overflow: hidden;
  background: var(--ed-brand, #BA61FE);
  border-radius: 48px;
  position: relative;
`;

const LoaderContainer = styled.div`
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translate(-50%);
  opacity: 0.5;
  z-index: 1;
`;

const Paypal: FC = () => {
  const [paypalClientId, setPaypalClientId] = useState('');
  const viewModel: IPayPalViewModel = ComposePaypalViewModel(window.location.href, APIServices, errorLogger);
  const currency = getCurrencyValue();

  useEffect(() => {
    async function setupClientId() {
      try {
        const id = await viewModel.getPayPalClientID();
        setPaypalClientId(id);
      } catch (error) {
        console.error("Ошибка загрузки PayPal Client ID", error);
      }
    }
    setupClientId();
  }, []);

  return (
    <PaypalComponentContainer>
      <LoaderContainer className="loaderContainer">
        <Loader />
      </LoaderContainer>
      {paypalClientId && (
        <PayPalScriptProvider
          key={currency}
          options={{
            clientId: paypalClientId,
            components: 'buttons',
            intent: 'capture',
            currency,
            vault: true,
          }}
        > 
          <SubscriptionPaypalButtons
            type="capture"
          />
        </PayPalScriptProvider>
      )}
    </PaypalComponentContainer>
  );
};

export default memo(Paypal);
